'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.settingsOnEnterSaga = settingsOnEnterSaga;
exports.plansOnEnterSaga = plansOnEnterSaga;
exports.livePricingOnEnterSaga = livePricingOnEnterSaga;
exports.addOnsOnEnterSaga = addOnsOnEnterSaga;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _selectors = require('redux/saga/selectors');

var _deep = require('helpers/deep');

var _requireFeature = require('routes/helpers/requireFeature');

var _Subscription = require('derivers/Subscription');

var _Subscription2 = _interopRequireDefault(_Subscription);

var _loginRedirectUrl = require('helpers/loginRedirectUrl');

var _loginRedirectUrl2 = _interopRequireDefault(_loginRedirectUrl);

var _memberStatus = require('enums/memberStatus');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(settingsOnEnterSaga),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(plansOnEnterSaga),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(livePricingOnEnterSaga),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(addOnsOnEnterSaga);

function settingsOnEnterSaga(client, nextState, replaceState) {
  return _regenerator2.default.wrap(function settingsOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 2:
          if (_context.sent) {
            _context.next = 5;
            break;
          }

          _context.next = 5;
          return (0, _effects.call)(replaceState, (0, _loginRedirectUrl2.default)(nextState.location));

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function plansOnEnterSaga(client, replaceState) {
  var profile, subscription, permissions;
  return _regenerator2.default.wrap(function plansOnEnterSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 2:
          profile = _context2.sent;

          if ((0, _memberStatus.memberStatus)('ACTIVE', profile && profile.membership && profile.membership.status)) {
            _context2.next = 7;
            break;
          }

          _context2.next = 6;
          return (0, _effects.call)(replaceState, '/settings');

        case 6:
          return _context2.abrupt('return', _context2.sent);

        case 7:
          _context2.next = 9;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userSubscription, [client, profile.id]);

        case 9:
          subscription = _context2.sent;

          if (!(!subscription || !subscription.allow_plan_selection)) {
            _context2.next = 13;
            break;
          }

          _context2.next = 13;
          return (0, _effects.call)(replaceState, '/settings');

        case 13:
          if (!(subscription && subscription.current_subscription && subscription.current_subscription.plan)) {
            _context2.next = 25;
            break;
          }

          _context2.next = 16;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userPermissions, [client, profile.id]);

        case 16:
          permissions = _context2.sent;

          if (!subscription.current_subscription.plan.commitment) {
            _context2.next = 22;
            break;
          }

          _context2.next = 20;
          return (0, _effects.call)(replaceState, '/settings/membership');

        case 20:
          _context2.next = 25;
          break;

        case 22:
          if (!permissions.feature_hide_classes) {
            _context2.next = 25;
            break;
          }

          _context2.next = 25;
          return (0, _effects.call)(replaceState, '/settings/live');

        case 25:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function livePricingOnEnterSaga(client, nextState, replaceState) {
  var params, subscription, profile;
  return _regenerator2.default.wrap(function livePricingOnEnterSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          params = nextState.params;

          if (!(params.planType === 'trial')) {
            _context3.next = 4;
            break;
          }

          _context3.next = 4;
          return (0, _effects.call)(_requireFeature.requireFeatureSaga, client, replaceState, 'classpass_live_trial', '/settings/live');

        case 4:
          _context3.next = 6;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.liveSubscription, [client]);

        case 6:
          subscription = _context3.sent;
          _context3.next = 9;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 9:
          profile = _context3.sent;

          if (!(0, _memberStatus.memberStatus)('CANCELLED', (0, _deep.deepExtract)('membership.status', profile, ''))) {
            _context3.next = 14;
            break;
          }

          _context3.next = 13;
          return (0, _effects.call)(replaceState, '/pricing/live');

        case 13:
          return _context3.abrupt('return', _context3.sent);

        case 14:
          if (!(subscription.data && !_Subscription2.default.isFreemium(subscription.data))) {
            _context3.next = 17;
            break;
          }

          _context3.next = 17;
          return (0, _effects.call)(replaceState, '/settings/live');

        case 17:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function addOnsOnEnterSaga(client, replaceState) {
  var profile;
  return _regenerator2.default.wrap(function addOnsOnEnterSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 2:
          profile = _context4.sent;

          if ((0, _memberStatus.memberStatus)('ACTIVE', profile && profile.membership && profile.membership.status)) {
            _context4.next = 6;
            break;
          }

          _context4.next = 6;
          return (0, _effects.call)(replaceState, '/settings');

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}